<template>
  <div v-tooltip.right="tooltipText" class="vcv-billing-lock">
    <i class="icon icon-locked"></i>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    feature: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapState('company_new', ['rates', 'tariffs']),

    tooltipText() {
      const feature = this.feature.replace('-', '_');
      let tariffs = [];
      let tariffsNames = '';

      if (this.tariffs !== null) {
        tariffs = this.tariffs.filter(x => x[feature]);

        tariffs.forEach(item => {
          tariffsNames += `, ${item.name}`;
        });

        tariffsNames = tariffsNames.slice(2);
      }

      if (tariffsNames) {
        return `Данный функционал доступен на тарифах ${tariffsNames}`;
      } else {
        return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.vcv-billing-lock {
  width: 30px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 18px;
    color: $main-dark;
  }
}
</style>
